import { createSlice, current } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import axios from "axios";
import { apiCallBegan } from "./api";
import moment from "moment";

const slice = createSlice({
  name: "reserves",
  initialState: { list: [], temporaryList: [], loading: false },

  // lastFetch: null,
  reducers: {
    reservesRequested: (reserves, action) => {
      reserves.loading = true;
    },

    reservesReceived: (reserves, action) => {
      reserves.list = action.payload;
      reserves.loading = false;
    },
    activeReservesGot: (reserves, action) => {
      reserves.temporaryList = action.payload;
      reserves.loading = false;
    },

    reservesRequestFailed: (reserves, action) => {
      reserves.loading = false;
    },

    reserveEdited: (reserves, action) => {
      // console.log(action);
      // return;
      const { id } = action.payload;
      const index = reserves.list.findIndex((reserve) => reserve.id === id);
      reserves.list[index] = { ...action.payload };
    },

    reserveAdded: (reserves, action) => {
      reserves.list.push(action.payload);
    },

    reserveDeleted: (reserves, action) => {
      reserves.list = reserves.list.filter(
        (reserve) => reserve.id !== action.payload
      );
    },
  },
});

export const {
  reserveAdded,
  reserveDeleted,
  reserveEdited,
  reservesReceived,
  activeReservesGot,
  reservesRequested,
  reservesRequestFailed,
} = slice.actions;
export default slice.reducer;

// Action Creators
const url = "/reserves";

export const loadReserves = () => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url,
      onStart: reservesRequested.type,
      onSuccess: reservesReceived.type,
      onError: reservesRequestFailed.type,
    })
  );
};

export const getActiveReserves = (model) =>
  apiCallBegan({
    url: "/reserves/activeReserves",
    method: "post",
    data: model,
    onSuccess: activeReservesGot.type,
  });
export const addReserve = (reserve) =>
  apiCallBegan({
    url,
    method: "post",
    data: reserve,
    onSuccess: reserveAdded.type,
  });

export const deleteReserve = (id) =>
  apiCallBegan({
    url: url + "/" + id,
    method: "delete",
    data: { id: id },
    onSuccess: reserveDeleted.type,
  });

export const editReserve = (reserve) =>
  apiCallBegan({
    url: url + "/" + reserve.id,
    method: "put",
    data: reserve,
    onSuccess: reserveEdited.type,
  });

// Selector

// Memoization
// reserves => get unresolved reserves from the cache

// export const getReservesById = (state, reserveId) => {
//   return state.entities.reserves.list.filter((x) => x.id === reserveId);
// };
// createSelector(
//   (state) => state.entities.reserves,
//   (reserves) => reserves.filter((reserve) => reserve.id === id)

// );

export const getReserveById = createSelector(
  (state, reserveId) =>
    state.entities.reserves.list.filter((x) => x.id === reserveId),
  (reserves) => reserves
);
